import { gql } from 'apollo-boost';

export const MODIFY_CART_PRESCRIPTION = gql`
  mutation doModifyCartPrescription($id: ID!, $data: CartPrescriptionInput!) {
    modifyCartPrescription(id: $id, data: $data) {
      id
      leftEyeProductVariant {
        id
        title
        handle
        attributes {
          attribute {
            id
            value
          }
        }
      }
      rightEyeProductVariant {
        id
        title
        handle
        attributes {
          attribute {
            id
            value
          }
        }
      }
    }
  }
`;
